import wixData from 'wix-data';

$w.onReady(function () {
	// Write your JavaScript here
    
    tri() ;
      
});


/**
*	Adds an event handler that runs when an input element's value
 is changed.
	[Read more](https://www.wix.com/corvid/reference/$w.ValueMixin.html#onChange)
*	 @param {Event} event
*/
export function dropdownType_change(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here:
    $w("#FiltreType").text = $w("#dropdownType").value;
    let valeurFiltreMois = $w("#FiltreMois").text ;

    console.log(" dans le dropdownType change");
    tri();

}

/**
*	Adds an event handler that runs when an input element's value
 is changed.
	[Read more](https://www.wix.com/corvid/reference/$w.ValueMixin.html#onChange)
*	 @param {Event} event
*/
export function dropdownMois_change(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here:
    //********************************** $w("#FiltreMois").text = $w("#dropdownMois").value;
    $w("#FiltreMois").text = $w("#dropdownMois").value;

    console.log(" dans le dropdownMois change");
    tri() ;

}

export function btnRenew_click(event) {
	
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w("#dropdownType").value = "" ;
    $w("#dropdownMois").value = "" ;
    $w("#FiltreMois").text = "Mois" ;
    $w("#FiltreType").text = "Type" ;
    $w("#radioFormat").value="toute";
	
    tri();

}

export function tri() {
    let valeurFiltreType = $w("#FiltreType").text ;
    let valeurFiltreMois = $w("#FiltreMois").text ;
    let localDate = new Date();
    let yearValue = localDate.getFullYear();
    let monthValue = localDate.getMonth();
    let dayValue = localDate.getDate();
    let dateValue = new Date(yearValue,monthValue,dayValue);

    console.log(valeurFiltreMois);
    console.log(valeurFiltreType);

    let filter = wixData.filter();

	// Sélection sur les épreuves
    filter = filter.eq("epreuve",true);
	// Sélection sur la catégorie
   	filter = filter.eq("categorie","9ef7db17-8dba-4e82-9aed-500b8bf7db79");
   

    // Sélection sur la date
    if ($w('#checkbox1').checked) {
        filter = filter.ge("dateDeDebut",dateValue);
    } 

    // Sélection sur le type de compétition
    if (valeurFiltreType != "Type") {
        filter = filter.eq("type",valeurFiltreType);
        console.log("filtré sur le type"); 
    }

    // Sélection sur le mois
    if (valeurFiltreMois != "Mois") {
        filter = filter.eq("moisConcerne", valeurFiltreMois)
        console.log("filtré sur le mois"); 
    }

    
    // Selection sur le format
    if ($w('#radioFormat').value == "equipe") { // si équipe
        filter = filter.eq("format","0f97bf9f-61c1-4aad-a0d6-4bdc4132753c")
    }
    if ($w('#radioFormat').value == "indiv") { // si équipe
        filter = filter.eq("format","63bc27e4-117d-411e-b56d-042b88be54c2")
    }


    $w("#datasetDonnees").setFilter(filter);
}


export function checkbox1_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
    if ($w('#checkbox1').checked) {
        console.log("Checkbox1 cochée") ;
    } else {
        console.log("Checkbox1 décochée") ;
    }

    tri();
}


export function radioFormat_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 

    console.log ($w('#radioFormat').value);

    tri();
}